import ReactOnRails from 'react-on-rails';
import App from './app.tsx';

ReactOnRails.register({ App, });
